module.exports = __webpack_public_path__ + "img/qrcode.6e7e6231.jpg";